require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import { ElSelect, ElOption, ElSwitch } from 'element-plus';

const el = document.getElementById('app');

InertiaProgress.init({
    color: 'black',
    delay: 50,
});

const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: name => import(
                    /* webpackChunkName: "/pages/[request]" */ `@/Pages/${name}`
            ).then(module => module.default)
        }),
})
    .mixin({ methods: { route } })
    .use(InertiaPlugin)
    .use(ElSelect)
    .use(ElOption)
    .use(ElSwitch)
    .mount(el);
